const COPY = {
  link: {
    analytics: {
      marketingAnalyticsEvent: {
        action: 'see_plans_pricing',
        tag: 'link',
        context: 'CTAs',
        location: 'river',
      },
    },
  },
  plans: [
    {
      cta1: {
        analytics: {
          marketingAnalyticsEvent: {
            action: 'request_demo_secret',
            tag: 'button',
            context: 'CTAs',
            location: 'pricing',
          },
        },
      },
      cta2: {
        analytics: {
          marketingAnalyticsEvent: {
            action: 'contact_sales_secret',
            tag: 'button',
            context: 'CTAs',
            location: 'pricing',
          },
        },
      },
    },
    {
      cta1: {
        analytics: {
          marketingAnalyticsEvent: {
            action: 'request_demo_code',
            tag: 'button',
            context: 'CTAs',
            location: 'pricing',
          },
        },
      },
      cta2: {
        analytics: {
          marketingAnalyticsEvent: {
            action: 'contact_sales_code',
            tag: 'button',
            context: 'CTAs',
            location: 'pricing',
          },
        },
      },
    },
  ],
} as const

export default COPY
